import axios from 'axios';
 
const baseUrl = process.env.REACT_APP_API_URL;
 
export const apiLogin = axios.create({
	baseURL: baseUrl,
})
 
export const api = axios.create({
  baseURL: baseUrl
});
 
api.interceptors.request.use((config) => {
	const token = localStorage.getItem('token')
	config.headers.Authorization = `Bearer ${token}`;
	return config;
});
 
const ignore401 = [
	'/api/authm/forgotpass',
	'/api/authm/changepass',
	'/api/authp/change-pin',
	'/api/authp/forgotpass',
]

api.interceptors.response.use(
  (response) => response,
  (error) => {
	if (error.response?.status === 401 && !ignore401.includes(error.response?.config?.url || '')) {
		// TODO: Cambiar esto por la Landing Page
	  	window.location.href = '/';
	}
	return Promise.reject(error);
  }
);
